<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <div id="introductories-page" class="qi-content">
        <header>
          <h1>Seleção da Introdutória</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row vs-justify="left">
          <SelectedCourseBox></SelectedCourseBox>
          <SelectedOfferBox></SelectedOfferBox>
        </vs-row>
        <h3 style="margin-bottom: 10px">Selecione uma Opção de Introdutória</h3>
        <vs-row>
          <vs-col>
            <vs-card
              style="box-shadow: 0px 0px 2px 1px #888888; border-radius:10px;"
              v-for="(introductory, introductoryIndex) in introductories"
              :key="introductoryIndex"
              actionable
              class="choosable-card"
            >
              <div @click="selectIntroductory(introductory)">
                {{ formatTitle(introductory) }} - Permite matrícula até
                {{ getLimitDate(introductory) }}
              </div>
            </vs-card>
          </vs-col>
          <vs-alert
            title="Falta Introdutória"
            class="margin"
            color="danger"
            v-if="error"
          >
            {{ error }}
          </vs-alert>
        </vs-row>
        <vs-row>
          <vs-button
            icon="arrow_back"
            style="width: 90%; margin: auto;"
            @click="backToClasses()"
            type="filled"
          >
            Voltar para Turmas
          </vs-button>
        </vs-row>
      </div>
    </div>
    <ConsultValidationMat />
  </div>
</template>

<script>
import SelectedCourseBox from "../components/SelectedCourseBox.vue";
import SelectedOfferBox from "../components/SelectedOfferBox.vue";
import ConsultValidationMat from "../components/ConsultValidationMat.vue"
import { getStepsInformation } from "../helpers/storage";
import CoursesService from "../services/courses";
import { formatDateToLocale, updateDiscussion } from "../helpers";
import moment from "moment";

export default {
  name: "Introcuctories",
  components: {
    SelectedCourseBox,
    SelectedOfferBox,
    ConsultValidationMat
  },
  data: () => ({
    selectedIntroductory: null,
    error: null,
    buttonDisabled: true,
    introductories: [],
  }),
  mounted() {
    this.$vs.loading({
      color: "danger",
    });

    const { offer, classData, course } = getStepsInformation();
    new CoursesService()
      .getIntroductories(
        offer.CODCURSO,
        offer.IDHABILITACAOFILIAL,
        classData.DTINICIAL,
        course.IDCLASSIFICACAO,
        classData.IDTURMADISC,
        offer.CODCAMPUS
      )
      .then(({ data }) => {
        const introductories = Array.isArray(data) ? data : [data];
        this.introductories = introductories;
        this.$vs.loading.close();
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error = response.data.error;
        }
        this.$vs.loading.close();
      });
  },
  methods: {
    formatTitle(introductory) {
      let datas = formatDateToLocale(introductory.DTINICIAL);
      const { offer } = getStepsInformation();

      if (introductory.DTINICIAL != introductory.DTFINAL)
        datas = `${formatDateToLocale(
          introductory.DTINICIAL
        )} a ${formatDateToLocale(introductory.DTFINAL)}`;

      if (offer.MODALIDADE != "D") {
        datas = datas + ` - ${introductory.TURNO} - ${introductory.HORARIO}`;
      }
      return datas;
    },
    getLimitDate(introductory) {
      const limitDate = moment(introductory.DTINICIAL).subtract(0, "days");
      return formatDateToLocale(limitDate);
    },

    selectIntroductory(introductory) {
      this.$vs.loading({
        color: "danger",
      });
      updateDiscussion(
        `Selecionou introdutória: ${this.formatTitle(introductory)}`,
        {
          introductory,
        }
      ).finally(() => {
        this.$router.push("/subjects");
        this.$vs.loading.close();
      });
    },

    backToClasses() {
      this.$router.push("/classes");
    },
  },
};
</script>

<style>
.vs-list {
  text-align: initial;
}
.space .con-vs-checkbox {
  margin-bottom: 8px;
  justify-content: flex-start;
}
#introductories-page .choosable-card {
  cursor: pointer;
}
#introductories-page .choosable-card:hover {
  cursor: pointer;
  font-weight: bold;
  box-shadow: 0px 0px 3.5px 2.5px #9B0E1C !important;
}
</style>
